import getSpamScenarioStore from '../selectors/getSpamScenarioStore';
import getSpamStore from '../store/store';
import { SpamScenarioId } from 'owa-junkmail-configuration';
import { mutatorAction } from 'satcheljs';

export const addToSpamList = mutatorAction(
    'addToSpamList',
    (spamScenarioId: SpamScenarioId, spamItem: string, indexToEdit: number) => {
        const store = getSpamScenarioStore(spamScenarioId);

        // If index is provided, edit inplace
        if (indexToEdit >= 0) {
            store.spamList[indexToEdit] = spamItem;
        } else {
            // This happens when we are adding a new item
            const spamList = store.spamList.slice();

            // Avoid duplicate entries.
            // VSO: 39038 enforce list size here and create error state
            const spamItemLC = spamItem.toLowerCase();
            if (spamList.every(spamItemL => spamItemL.toLowerCase() !== spamItemLC)) {
                spamList.unshift(spamItem);
                store.spamList = spamList;
            }
        }
    }
);

export const deleteFromSpamList = mutatorAction(
    'deleteFromSpamList',
    (spamScenarioId: SpamScenarioId, indexToDelete: number) => {
        const store = getSpamScenarioStore(spamScenarioId);
        store.spamList.splice(indexToDelete, 1);
    }
);

export const createSpamStore = mutatorAction(
    'createSpamStore',
    (spamScenarioId: SpamScenarioId, spamList: string[]) => {
        const initStore = {
            spamList: null,
            newSpamItem: null,
            indexToEdit: -1,
            searchQuery: '',
            errorMessage: '',
        };
        initStore.spamList = spamList ? [...spamList] : null;

        const store = getSpamStore();
        store.spamStores.set(spamScenarioId, initStore);
    }
);
